module.exports = __webpack_public_path__ + "static/img/1-9.820ea67.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/home/1-9.png
// module id = ZUFi
// module chunks = 15